<template>
	<section v-if="isShowH" class="py-5 box-layout-details" style="overflow:auto;height:100vh;">
        <!-- <div v-if="!isShowAnalytics" class="loader1">
            <div>
                <div class="lds-ripple">
                <div></div>
                <div></div>
                </div>
            </div>
        </div> -->
        <div>
            <b-form class="p-3 row align-items-center">
                <b-form-group label="Start Date" class="text-left col-sm-4 start-date">
                    <b-form-group>
                        <b-form-datepicker
                            v-model="form.date_s"
                            size="sm"
                            required/>
                    </b-form-group>
                    <!-- <b-form-group>
                        <b-form-timepicker
                            v-model="form.time"
                            size="sm"
                            required/>
                    </b-form-group> -->
                </b-form-group>
                <b-form-group label="End Date" class="text-left col-sm-4 end-date">
                    <b-form-group class="date_picker_add">
                        <b-form-datepicker 
                            v-model="form.date_e"
                            size="sm"
                            required/>
                    </b-form-group>
                    <!-- <b-form-group>
                        <b-form-timepicker
                            v-model="form.time"
                            size="sm"
                            required/>
                    </b-form-group> -->
                </b-form-group>
                <b-button-group class="w-100 col-sm-4 filter-btn">
                    <b-button variant="outline-primary" @click="applyFilter">Filter</b-button>

                    <download-csv v-if="this.dateRangeProspect.length" style="margin-left: 10px;"
                        class="btn-default"
                        :data="this.getCSVData()"
                        :name="this.getFileName()"
                        :fields="reportingFields"
                        :labels="reportingLabels"
                        >
                        <b-button variant="outline-primary" >Export Prospects</b-button>
                    </download-csv>
                </b-button-group>
            </b-form>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="row align-items-center m-l-0">
                                <!-- <div class="col-sm-12 text-center" style="position:absolute;">
                                    <div class="loader4"></div>
                                </div> -->
                                <div class="col-auto" style="position: absolute;top: 0;bottom: 0;margin: auto;display: flex;align-items: center;right:0;">
                                    <img src="../../../../public/img/TasksUser1.png" style="width: 50px;" class="nav-icon w-80" >
                                </div>
                                <div class="col-auto" style="padding-left:85px;height:120px;">
                                    <h6 class="m-b-10">Total Prospects</h6>
                                    <div v-if="!showProspectAnalytics" class="col-sm-12 text-center" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4"></div>
                                    </div>
                                    <h2  v-if="showProspectAnalytics"  class="m-b-0">{{totalProspect}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="row align-items-center m-l-0">
                                
                                <div class="col-lg-2" ><img src="../../../../public/img/TasksUser1.png" style="width: 50px;" class="nav-icon w-80" ></div>
                                <div class="col-lg-10" style="padding-left:30px;height:120px;">
      
                                    <h6 class="m-b-10">Total Prospects</h6>
                                    
                                    <span v-if="!isShowAnalytics" class="m-b-0" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4"></div>
                                    </span>
                                    <h2 v-if="isShowAnalytics" class="m-b-0">{{totalProspect}}</h2>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div> -->
                    <div class="col-lg-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="row align-items-center m-l-0">
                                <!-- <div class="col-sm-12 text-center" style="position: absolute;
                                        padding-left: 100px;
                                        text-align: left !important;
                                        padding-top: 30px;">
                                    <div class="loader4"></div>
                                </div> -->
                                <!-- <div class="col-lg-2"> -->
                                    <!-- <img src="../../../../public/img/TasksCreated1.png" class="nav-icon w-80"  style="max-width: 45px;"> -->
                                    <!-- <v-icon class="text-white" scale="3" name="tasks"></v-icon> -->
                                <!-- </div> -->
                                <div class="col-auto" style="position: absolute;top: 0;bottom: 0;margin: auto;display: flex;align-items: center;right:0;">
                                    <img src="../../../../public/img/TasksCreated1.png" style="width:30px" class="nav-icon w-80" >
                                </div>
                                <div class="col-auto" style="padding-left:85px;height:120px;">
                                    <h6 class="m-b-10">Tasks Created</h6>
                                    <div v-if="!showProspectAnalytics" class="col-sm-12 text-center" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4"></div>
                                    </div>
                                    <h2 v-if="showProspectAnalytics" class="m-b-0">{{totalCreatedTask}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="row align-items-center m-l-0">
                                <!-- <div class="col-sm-12 text-center" style="position: absolute;
                                        padding-left: 100px;
                                        text-align: left !important;
                                        padding-top: 30px;">
                                    <div class="loader4"></div>
                                </div> -->
                                <!-- <div class="col-lg-2 custom-icon"> -->
                                    <!-- <img src="../../../../public/img/TasksList1.png" class="nav-icon w-80" style="max-width: 45px;"> -->
                                    <!-- <v-icon class="text-white" scale="3" name="calendar-check"></v-icon> -->
                                <!-- </div> -->
                                <div class="col-auto" style="position: absolute;top: 0;bottom: 0;margin: auto;display: flex;align-items: center;right:0;">
                                    <img src="../../../../public/img/TasksList1.png" style="width:30px" class="nav-icon w-80" >
                                </div>
                                <div class="col-auto" style="padding-left:85px;height:120px;">
                                    <h6 class="m-b-10">Task Completed</h6>
                                    <div v-if="!showProspectAnalytics" class="col-sm-12 text-center" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4"></div>
                                    </div>
                                    <h2 v-if="showProspectAnalytics" class="m-b-0">{{totalCompeletedTask}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="row align-items-center m-l-0">
                                <!-- <div class="col-sm-12 text-center" style="position:absolute;">
                                    <div class="loader4"></div>
                                </div> -->
                                <div class="col-auto" style="position: absolute;top: 0;bottom: 0;margin: auto;display: flex;align-items: center;right:0;">
                                    <v-icon class="text-white" scale="3" name="comments"></v-icon>
                                </div>
                                <div class="col-auto" style="padding-left:85px;height:120px;">
                                    <h6 class="m-b-10">Inbound Messages</h6>
                                    <div v-if="!isShowConvoAnalytics" class="col-sm-12 text-center" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4"></div>
                                    </div>
                                    <h2  v-if="isShowConvoAnalytics"  class="m-b-0">{{totalInboundMessage}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="row align-items-center m-l-0">
                                <div class="col-auto" style="position: absolute;top: 0;bottom: 0;margin: auto;display: flex;align-items: center;right:0;">
                                    <v-icon class="text-white" scale="3" name="comment"></v-icon>
                                </div>
                                <div class="col-auto" style="padding-left:85px;height:120px;">
                                    <h6 class="m-b-10">Outbound Messages</h6>
                                    <div v-if="!isShowConvoAnalytics" class="col-sm-12 text-center" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4"></div>
                                    </div>
                                    <h2 v-if="isShowConvoAnalytics" class="m-b-0">{{totalOutBoundMessage}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="row align-items-center m-l-0">
                                <div class="col-auto" style="position: absolute;top: 0;bottom: 0;margin: auto;display: flex;align-items: center;right:0;">
                                    <v-icon class="text-white" scale="3" name="reply-all"></v-icon>
                                </div>
                                <div class="col-auto" style="padding-left:85px;height:120px;">
                                    <h6 class="m-b-10">Response Rate</h6>
                                    <div v-if="!isShowConvoAnalytics" class="col-sm-12 text-center" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4"></div>
                                    </div>
                                    <h2 v-if="isShowConvoAnalytics" class="m-b-0">{{totalResonseRate}}%</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid">
                <div class="row" style="padding-top:50px;">
                    <div class="col-lg-6 " style="display:flex !important;justify-content:flex-end !important;">
                        <!-- <div  width="100" id="chart"></div> -->
                        <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important; max-width: 400px;margin-left: auto;">
                                        <div class="loader4 "></div>
                                    </div>
                        <div v-if="isShowAnalytics" class="first-chart">
                            <apexcharts width="360" height="200" type="donut"  :options="stageChartOptions" :series="stageSeries" style="margin-right:0; margin-left: auto;max-height:200px;min-height: 200px;"></apexcharts>
                        </div>

                    </div>
                    <div class="col-lg-6 ">
                        <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important;max-width: 200px;">
                            <div class="loader4 "></div>
                        </div>
                        <div v-if="isShowAnalytics">
                            <apexcharts width="360" height="200" type="donut" style="max-height:200px;min-height: 200px;" :options="sourceChartOptions" :series="sourceSeries" ></apexcharts>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding-top:50px;">
                    <div class="col-lg-6 " style="display:flex !important;justify-content:flex-end !important;">
                        <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important; max-width: 400px;margin-left: auto;">
                            <div class="loader4 "></div>
                        </div>
                        <div v-if="isShowAnalytics" class="first-chart">
                            <apexcharts width="360" height="200" type="bar"  :options="tagChartOptions" :series="tagSeries" style="margin-right:0; margin-left: auto;max-height:200px;min-height: 200px;"></apexcharts>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>  
<script>
import { db } from 'src/db'
import { mapState } from 'vuex'
// import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment';

	export default {
		name: "ReportingPage",
        components: {
            apexcharts: VueApexCharts,
        },
		computed: {
			...mapState('firebase', ['user','prospects', 'convos'])
        },

        mounted() {
            // var chart = new ApexCharts(document.querySelector("#chart"), this.options);
            // chart.render();
        },
        
        created() {
            setTimeout(() => {
                this.getAnalytics();
            this.isShowH = true;
            }, 0);
        },
        methods: {
            async getAnalytics() {
                this.dateRangeProspect = [];
                // let dateRangeCreatedTask = []
                // let dateRangeCompeletedTask = [];
                let sourceArray = [];

                // let convertedSDate = new Date(this.form.s_date).setHours(0,0,0,0);
                // let convertedEDate = new Date(this.form.e_date).setHours(23,59,59,999);
                let convertedSDate = moment(this.form.s_date).valueOf();
                let convertedEDate = moment(this.form.e_date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).valueOf();

                this.totalProspect = 0;
                this.totalCreatedTask = 0;
                this.totalCompeletedTask = 0;
                this.totalInboundMessage = 0;
                this.totalOutBoundMessage = 0;
                this.totalResonseRate = 0;

                this.stageChartOptions.labels = [];
                var stages = [];
                Object.assign(stages,this.user.Stages) ;
                // this.stageChartOptions.labels = stages
                // stages.push('Uncategorized','Archived');
                stages.push('Archived');
                // this.stageChartOptions.labels.push('Uncategorized','Archived');
                this.stageChartOptions.labels = stages;
                this.stageChartOptions.labels = this.stageChartOptions.labels.filter((item, i, ar) => ar.indexOf(item) === i);
                this.isShowTagAnalytics = false;
                this.tagChartOptions.xaxis.categories = [];
                this.tagChartOptions.xaxis.categories = this.user.Folders;
                this.tagSeries[0].data = [];
                if (this.user.Folders && this.user.Folders.length) {
                    for(let f of this.user.Folders) {
                        let count = 0;
                        if (this.prospects && this.prospects.length) {
                            for(let p of this.prospects) {
                                if ((p.DateCreated >= convertedSDate && p.DateCreated <= convertedEDate)) {
                                    if (p.Tags && p.Tags.length ) {
                                        if (p.Tags.indexOf(f) > -1) {
                                            count++;
                                        }
                                    }
                                    
                                }
                            }
                        }
                        
                        this.tagSeries[0].data.push(count);   
                    }
                    this.isShowTagAnalytics = true;
                }
                else {
                    this.isShowTagAnalytics = true;
                }
                if (this.prospects.length) {
                    for(let p of this.prospects) {
                        if ((p.DateCreated >= convertedSDate && p.DateCreated <= convertedEDate)) {
                            this.dateRangeProspect.push(p);
                            this.totalProspect = this.totalProspect+1;
                            if(p.hasOwnProperty('Source') && p.Source) {
                                sourceArray.push(p.Source);
                            }
                        }
                        if (p.Tasks) {
                            for(let t of p.Tasks) {
                                if ((t.CreatedOn >= convertedSDate && t.CreatedOn <= convertedEDate)) {
                                    // dateRangeCreatedTask.push(t);
                                    this.totalCreatedTask = this.totalCreatedTask+1;
                                }
                                if (t.CompletedOn && (t.CompletedOn >= convertedSDate && t.CompletedOn <= convertedEDate)){
                                    // dateRangeCompeletedTask.push(t);
                                    this.totalCompeletedTask = this.totalCompeletedTask+1;
                                }
                            }
                        }
                       
                    }
                    this.showProspectAnalytics = true;
                }else {
                    this.showProspectAnalytics = true;
                }
                // let mesRef = await db.collectionGroup('Messages').where('Body', '==', 'Helllooo 123').get();
                // let messageList = mesRef.docs.map((doc) => {
                //                         let data = {...doc.data() };
                //                         return data;
                //                 })
                // var museums = db.collectionGroup('Messages').where('Body', '==', 'Helllooo 123');
                // museums.get().then((querySnapshot) => {
                //     querySnapshot.forEach((doc) => {
                //         //eslint-disable-next-line
                //         console.log(doc.id, ' => ', doc.data());
                //     });
                // });
                // 9OK5P3DhFUckJaSJFq9a
                // let mesRef = await db.collection(`Conversations/{id}/Messages`).get();
                // let messageList = mesRef.docs.map((doc) => {
                //             let data = {...doc.data() };
                //             return data;
                //         });
                // eslint-disable-next-line
                // console.log(messageList);

                if (this.convos.length) {
                    for (let c of this.convos) {
                        if (c.DateUpdated && (c.DateUpdated >= convertedSDate && c.DateUpdated <= convertedEDate)) {
                            let mesRef = await db.collection(`Conversations/${c.id}/Messages`).get();
                                let messageList = mesRef.docs.map((doc) => {
                                let data = {...doc.data() };
                                return data;
                            })
                            if (messageList.length) {
                                for (let m of messageList) {
                                    if (m.Date && (m.Date >= convertedSDate && m.Date <= convertedEDate)){
                                        if (m.Inbound) {
                                            this.totalInboundMessage = this.totalInboundMessage+1;
                                        }else {
                                            this.totalOutBoundMessage = this.totalOutBoundMessage+1;
                                        }
                                    }
                                }
                            }
                        }
                        
                    }
                    if (this.totalInboundMessage && this.totalOutBoundMessage) {
                        this.totalResonseRate = ((this.totalInboundMessage / this.totalOutBoundMessage)*100).toFixed(2);
                        this.totalResonseRate = Math.round(this.totalResonseRate);
                    }
                    this.isShowConvoAnalytics = true;
                }else {
                    this.isShowConvoAnalytics = true;
                }
                
                // make unique value array
                sourceArray = sourceArray.filter((item, i, ar) => ar.indexOf(item) === i);
                this.sourceChartOptions.labels = [];
                this.sourceChartOptions.labels = sourceArray;


                if (this.dateRangeProspect.length) {
                    this.stageSeries = [];
                    this.sourceSeries = [];
                    for(let stage of this.stageChartOptions.labels) {
                        // if (stage == 'Uncategorized') {
                        //     let s = this.dateRangeProspect.filter(pr =>  (pr.Status == stage || pr.Status == null));
                        //     this.stageSeries.push(s.length)
                        // }else {
                            let s = this.dateRangeProspect.filter(pr =>  pr.Status == stage);
                            this.stageSeries.push(s.length)
                        // }
                        
                    }

                    for(let source of this.sourceChartOptions.labels) {
                        let s = this.dateRangeProspect.filter(pr =>  pr.Source == source);
                        this.sourceSeries.push(s.length)
                    }
                    this.isShowAnalytics = true;
                    
                }else {
                    this.isShowAnalytics = true;
                }
                
            },
            applyFilter() {
                if (this.isShowAnalytics && this.isShowConvoAnalytics && this.showProspectAnalytics && this.isShowTagAnalytics) {
                    this.downloadCount = 0;
                    this.form.s_date = this.form.date_s;
                    this.form.e_date = this.form.date_e;
                    this.isShowAnalytics = false;
                    this.isShowTagAnalytics = false;
                    // this.showProspectAnalytics = false;
                    this.getAnalytics();
                }
            },
            getFileName() {
                return  this.user.Company+'-'+this.$parsePlainDate(new Date(this.form.date_s).getTime())+'-'+this.$parsePlainDate(new Date(this.form.date_e).getTime())+'-prospects.csv';
            },
            getCSVData() {
                
                let csvDataJson = this.dateRangeProspect;
                // let csvDataJson = this.dateRangeProspect.sort((a, b) => b.DateCreated - a.DateCreated);
                if (this.downloadCount == 0) {
                    this.downloadCount = this.downloadCount+1;
                    csvDataJson.sort((a, b) => b.DateCreated - a.DateCreated);
                    csvDataJson.forEach(element => {
                        let dc = this.$parsePlainDate(element.DateCreated) + '-' + this.$parsePlainTime(element.DateCreated);
                        // element.DateCreated = dc;
                        element['DateCreatedDuplicte'] = dc;
                        /*if (element.Starred == true) {
                            element.Starred = 'Yes'
                        }else if (element.Starred == false){
                            element.Starred = 'No'
                        }*/
                        if (element.Starred == true) {
							element['DuplicateStarred'] = 'Yes'
						}else if (element.Starred == false){
							element['DuplicateStarred'] = 'No'
						}
                        if (element.Notes && element.Notes.length) {
							const newObj = element.Notes.map(key1 => {
								let key11 = this.$parsePlainDate(key1['date']);
								let value = key1['description'];
								return { [key11]:value }
							});
							element['DuplicateNotes'] = JSON.stringify(newObj);                            
						}
                        /*if (Object.keys(element.Notes).length) {
                            const newObj = Object.keys(element.Notes).map(key => {
                                let key11 = this.$parsePlainDate(key)
                                let value = element.Notes[key];
                                return { [key11]:value }
                            });
                            element['DuplicateNotes'] = JSON.stringify(newObj);                            
                        }*/
                    });
                }
                return csvDataJson;
            },
        },
        data() {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
			return {
                isShowH:false,
                stageChartOptions: {
                    chart: {
                        // type: 'donut',
                        // width: '100%',
                        // height: 400
                    },
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'middle',
                    },
                    plotOptions: {
                        pie: {
                            // customScale: 0.8,
                             donut: {
                                size: '50%',
                            },
                        // offsetY: 20,
                        },
                        stroke: {
                            colors: undefined
                        },
                        labels: {
                            show:true,
                            name:{
                                show:true,
                                color: 'red'
                            }
                        }
                    },
                    // colors: colorPalette,
                    title: {
                        text: 'Stage Distribution',
                        style: {
                            fontSize: '18px'
                        }
                    },
                   
                    labels: [],
                    legend: {
                        position: 'left',
                        offsetY: 30
                    }
                },
                sourceChartOptions: {
                    chart: {
                        // type: 'donut',
                        // width: '100%',
                        // height: 400
                    },
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'middle',
                    },
                    plotOptions: {
                        pie: {
                        // customScale: 0.8,
                        donut: {
                            size: '50%',
                        },
                        // offsetY: 20,
                        },
                        stroke: {
                            colors: undefined
                        }
                    },
                    // colors: colorPalette,
                    title: {
                        text: 'Source Distribution',
                        style: {
                            fontSize: '18px'
                        }
                    },
                   
                    labels: [],
                    legend: {
                        position: 'left',
                        offsetY: 30
                    }
                },
                
                tagSeries: [{
                    name:'',
                    data: []
                }],
                tagChartOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                        },
                    },
                    title: {
                        text: 'Tag Distribution',
                        style: {
                            fontSize: '18px'
                        }
                    },
                    // dataLabels: {
                    //     enabled: false
                    // },
                    xaxis: {
                        categories: [],
                    },
                    legend: {
                        position: 'left',
                        offsetY: 30,
                        floating: false,
                    }
                },
                stageSeries: [],
                sourceSeries:[],
				isShowAnalytics:false,
                items:[],
                form: {
                    date_s:firstDay,
                    date_e:new Date(),
					s_date: firstDay,
					e_date: new Date(),
				},
                totalProspect:0,
                totalCreatedTask:0,
                totalCompeletedTask:0,
                totalInboundMessage:0,
                totalOutBoundMessage:0,
                totalResonseRate:0,

                showProspectAnalytics:false,
                isShowConvoAnalytics:false,
                dateRangeProspect:[],
                reportingFields:['DateCreatedDuplicte','First','Last','Email','Number','Zip','Status','DuplicateStarred','Source','Tags','DuplicateNotes'],
                reportingLabels:{
                    DateCreatedDuplicte: 'Date Created',
                    First: 'First Name',
                    Last: 'Last Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateStarred:'Starred',
                    DuplicateNotes:'Notes'
                },
                downloadCount:0,
                isShowTagAnalytics:false,
			}
		}
	}
</script>

<style scoped>
    .tatext-card-layout{padding: 20px;box-shadow: 0 2px 10px -1px rgb(69 90 100 / 30%);margin-bottom: 30px;transition: box-shadow .2s ease-in-out;}
    .text-c-blue { background-color: #06187c; color: white;}
    .f-36 { font-size: 36px;}
    .loader1 {
        position: fixed;
        z-index: 1010;
        top: 50%;
        margin: auto;
        left: 50%;
        z-index: 1111;
    }

    .loader1:before {
        content: "";
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 1111;
    }

    .lds-ripple {
        display: inline-block;
        top: 50%;
        position: relative;
        width: 64px;
        height: 64px;
    }

    .lds-ripple div {
        position: absolute;
        top: 50%;
        border: 4px solid #000000;
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }

    .lds-ripple div:nth-child(2) {
        animation-delay: -0.5s;
    }
    .first-chart .apexcharts-canvas {
        margin-left: auto !important;
    }
    .loader4 {
   width:30px;
   height:30px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:5px solid;
   border-top-color:#fff;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#fff;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}

.loader-blue .loader4{
    border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
   border-right-color:rgba(255,255,255, 0.3);
}
.loader-blue{
    position: absolute;
    padding-left: 0px;
    top: 0;z-index: 9999;
    margin: auto;
    bottom: 0;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}
/* 
.custom-icon{
        display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
} */

    @keyframes lds-ripple {
        0% {
            top: 28px;
            left: 28px;
            width: 0;
            height: 0;
            opacity: 1;
        }
        100% {
            top: -1px;
            left: -1px;
            width: 58px;
            height: 58px;
            opacity: 0;
        }
    }
</style>